export const environment = {
    production: true,
    VERSION : "27884"
};